// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const listTagsApi = (query = {}) => api().get('/tags', {params: query});

export default listTagsApi;
